query DashboardData(
	$days: Int!
	$days2n: Int!
	$customFieldsFilter: ConditionStringArray
	$customFieldsFilterExcludes: ConditionStringArray
	$calculationDateFrom: ConditionDateTime
	$calculationDateTo: ConditionDateTime
	$environmentFilter: ConditionString
	$unitIdFilter: ConditionString
	$environmentCustomFieldsFilter: ConditionStringArray
	$environmentsFilter: ConditionString
) {
	wsdkIssuesCount: wsdk_test_runs(
		limit: 500
		run_time_last_n_days: { value: [$days] }
		custom_fields_ne_any_item_for_any_value: $customFieldsFilterExcludes
		and: [
			{
				or: [
					{ custom_fields_eq_any_item_for_any_value: $environmentCustomFieldsFilter }
					{ environments_eq_any_item: $environmentsFilter }
				]
			}
			{ custom_fields_eq_any_item_for_any_value: $customFieldsFilter }
		]
		group: run_time_truncDay
	) {
		run_time_truncDay
		critical_issues_sum
		serious_issues_sum
		total_issues_sum
	}
	wsdkIssuesCount2n: wsdk_test_runs(
		limit: 500
		run_time_last_n_days: { value: [$days2n] }
		custom_fields_ne_any_item_for_any_value: $customFieldsFilterExcludes
		and: [
			{
				or: [
					{ custom_fields_eq_any_item_for_any_value: $environmentCustomFieldsFilter }
					{ environments_eq_any_item: $environmentsFilter }
				]
			}
			{ custom_fields_eq_any_item_for_any_value: $customFieldsFilter }
		]
		group: run_time_truncDay
	) {
		run_time_truncDay
		critical_issues_sum
		serious_issues_sum
		total_issues_sum
	}
	wfaIssuesCount: wfa_session_runs(
		limit: 500
		run_time_last_n_days: { value: [$days] }
		custom_fields_ne_any_item_for_any_value: $customFieldsFilterExcludes
		and: [
			{
				or: [
					{ custom_fields_eq_any_item_for_any_value: $environmentCustomFieldsFilter }
					{ environments_eq_any_item: $environmentsFilter }
				]
			}
			{ custom_fields_eq_any_item_for_any_value: $customFieldsFilter }
		]
		group: run_time_truncDay
	) {
		run_time_truncDay
		critical_issues_sum
		serious_issues_sum
		total_issues_sum
	}
	wfaIssuesCount2n: wfa_session_runs(
		limit: 500
		run_time_last_n_days: { value: [$days2n] }
		custom_fields_ne_any_item_for_any_value: $customFieldsFilterExcludes
		and: [
			{
				or: [
					{ custom_fields_eq_any_item_for_any_value: $environmentCustomFieldsFilter }
					{ environments_eq_any_item: $environmentsFilter }
				]
			}
			{ custom_fields_eq_any_item_for_any_value: $customFieldsFilter }
		]
		group: run_time_truncDay
	) {
		run_time_truncDay
		critical_issues_sum
		serious_issues_sum
		total_issues_sum
	}
	scoreWebProductsDaily: score_web_products(
		limit: 500
		calculation_date_ge: $calculationDateFrom
		calculation_date_le: $calculationDateTo
		environment_eq: $environmentFilter
		unit_id_eq: $unitIdFilter
		timeframe_days_eq: { value: [$days] }
	) {
		unit_id
		environment
		timeframe_days
		issues: unique_issues
		issues_critical: unique_issues_critical
		issues_seriouse: unique_issues_serious
		calculation_date
		created_at
	}
	scoreWebProductsDailyTotal: score_web_products(
		limit: 500
		calculation_date_ge: $calculationDateFrom
		calculation_date_le: $calculationDateTo
		environment_eq: $environmentFilter
		unit_id_eq: $unitIdFilter
		timeframe_days_eq: { value: [$days] }
	) {
		unit_id
		environment
		timeframe_days
		issues: total_issues
		issues_critical: total_issues_critical
		issues_seriouse: total_issues_serious
		calculation_date
	}
}
